<!--
 * @Author: ZhaoG
 * @Date: 2025-04-23 15:52:22
 * @LastEditors: ZhaoG
 * @LastEditTime: 2025-06-06 15:31:34
 * @FilePath: \gcp-fe\src\app\shop\components\noticeList.vue
 * @Description: 政策法规和通知公告模板
-->
<template>
  <div class="notice-list mt20">
    <div>
      <div class="titleBox">
        <p>{{ getworkDynamicsList.label }}</p>
        <el-link
          :underline="false"
          type="info"
          class="notice-list-view-all caigougonggao"
          @click="handleViewAll()"
          >更多 ></el-link
        >
      </div>
      <div class="workDynamics" v-if="getworkDynamicsList.list.length > 0">
        <div v-for="(item2, index2) in getworkDynamicsList.list" :key="index2">
          <div class="workDynamics-item-title">
            <div class="display-flex">
              <span class="iconTitle"
                >{{ `0${index2 + 1}` }}
                <!-- 【{{
                        getworkDynamicsList.labelItem
                      }}】 -->
              </span>
              <span
                style="cursor: pointer;text-align: left;"
                class="ellipsis"
                :title="item2.title"
                @click="handleOp(item2)"
              >
                {{ item2.title }}
              </span>
            </div>
            <div style="color: #999999;">
              {{ item2.publishTime.substring(0, 10) }}
            </div>
          </div>
        </div>
      </div>
      <div class="workDynamics noDataBox" v-else>
        <img
          style="width: 214px;height: 155px;"
          src="../img/empt.png"
          alt=""
          srcset=""
        />
      </div>
    </div>
  </div>
</template>

<script>
// import Cookies from "js-cookie";
// import { addUrlPerFix } from "@/basa/utils";
import { updateNoticeHits } from "../api/shopping";

export default {
  name: "noticeList",
  props: ["workDynamicsList", "type"],
  data() {
    return {
      tabName: "first",
      nodeList: [],
      agentIdEncrypt: ""
    };
  },
  computed: {
    getworkDynamicsList() {
      return this.workDynamicsList;
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {},
    handleOp(row) {
      // console.log(row, "row");
      updateNoticeHits({ noticeId: row.id });
      this.$router.push({
        path: "/noticeDetail",
        query: {
          id: row.id,
          type: this.type
        }
      });
      // if (["107407", "118352", "119934"].includes(row.baseAppId)) {
      //   //租赁
      //   row.noticeDetailsUrl =
      //     addUrlPerFix(process.env.VUE_APP_YZ_URL) +
      //     "/leaseMall/viewNoticeDetail?" +
      //     row.noticeDetailsUrl.split("?")[1];
      // } else if (["118353", "107412", "119952"].includes(row.baseAppId)) {
      //   //物流
      //   row.noticeDetailsUrl =
      //     addUrlPerFix(process.env.VUE_APP_WLY_URL) +
      //     "/#/detail?" +
      //     row.noticeDetailsUrl.split("?")[1];
      // } else {
      //   row.noticeDetailsUrl =
      //     addUrlPerFix(process.env.VUE_APP_BASE_URL) +
      //     "/viewNoticeDetail?" +
      //     row.noticeDetailsUrl.split("?")[1];
      // }
      // if (Cookies.get("sup_code")) {
      //   let tagerUrl =
      //     row.noticeDetailsUrl + "&supCode=" + Cookies.get("sup_code");
      //   if (
      //     ["107407", "118352", "119934", "118353", "107412", "119952"].includes(
      //       row.baseAppId
      //     )
      //   ) {
      //     window.open(tagerUrl + "&isJRZL=1&searchType=首页", "_blank");
      //   } else {
      //     window.location.href = tagerUrl + "&isJRZL=1&searchType=首页";
      //   }
      // } else {
      //   if (
      //     ["107407", "118352", "119934", "118353", "107412", "119952"].includes(
      //       row.baseAppId
      //     )
      //   ) {
      //     window.open(
      //       row.noticeDetailsUrl + "&isJRZL=1&searchType=首页",
      //       "_blank"
      //     );
      //   } else {
      //     window.location.href =
      //       row.noticeDetailsUrl + "&isJRZL=1&searchType=首页";
      //   }
      // }
    },

    handleViewAll() {
      this.$router.push({
        path: "/noticeList",
        query: {
          type: this.type
        }
      });
      // let routeUrl = this.$router.resolve({
      //   path: "/searchList",
      //   query: {
      //     type: 98
      //   }
      // });
      // window.location.href = routeUrl.href;
      // this.$router.push({
      //   path: "/searchList",
      //   query: {
      //     type: 98
      //   }
      // });
      // 跳转中交供应商门户首页: sp.iccec.cn  /searchList?type=98&isJRZL=1
      // window.location.href =
      //   `${this.$addUrlPerFix(process.env.VUE_APP_SP_URL)}` +
      //   "/searchList?type=98&isJRZL=1&searchType=首页";
    }
  }
};
</script>

<style scoped lang="scss">
.notice-list {
  width: 580px;
  position: relative;

  .titleBox {
    display: flex;
    margin-bottom: 16px;

    p {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 24px;
      color: #181818;
    }
  }

  .notice-list-view-all {
    position: absolute;
    right: 15px;
    // top: 15px;
    line-height: 18px;
    font-size: 13px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #999999;

    &:hover {
      color: #0089ef;
    }
  }
}

.workDynamics {
  display: flex;
  flex-direction: column;
  align-content: flex-start;
  box-sizing: border-box;
  overflow: hidden;
  background: #f2f7fc;
  height: 204px;
  justify-content: flex-start;
  .workDynamics-item-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 13px;
    color: #4a4a4a;
    padding: 4px 10px;
    .display-flex {
      display: flex;
      align-items: center;
      .iconTitle {
        // display: inline-block;

        // background: #feb532;
        border-radius: 2px;
        font-size: 13px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        text-align: center;
        margin-right: 5px;
      }
      .ellipsis {
        display: block;
        width: 454px;
        height: 30px;
        line-height: 30px;
        font-size: 13px;
        color: #4a4a4a;
        font-weight: 400;
        font-family: PingFangSC, PingFang SC;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;

        &:hover {
          color: #0089ef;
        }
      }
    }
  }
}

.noDataBox {
  display: flex;
  align-items: center;
  justify-content: center;
}
.icon-notice-list {
  position: absolute;
  left: 20px;
  top: 16px;
  color: #0089ef;
}

.caigougonggao {
  transform: translateX(10px);
}
</style>
